"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[106],{

/***/ 88518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SEOFORTAG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38864);




var baseSEO = {
    title: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_TITLE */ .qN,
    description: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_DESC */ .a0,
    openGraph: {
        type: "article",
        locale: "th_TH",
        url: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_URL.WEB */ .h$.WEB,
        title: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_TITLE */ .qN,
        description: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_DESC */ .a0,
        site_name: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_NAME */ .Ey,
        images: [
            {
                url: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .IMAGE_DEFAULT */ .TH,
                width: "750",
                height: "422",
                alt: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_NAME */ .Ey
            }
        ]
    },
    additionalMetaTags: [
        {
            name: "keywords",
            content: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_KEYWORD */ .kG
        }
    ]
};
var SEO = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, baseSEO), {
    noindex: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn,
    nofollow: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn
});
var SEOFORTAG = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, baseSEO), {
    noindex: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn,
    nofollow: false
});

/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 38864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ WEB_NAME; },
/* harmony export */   "Nt": function() { return /* binding */ WEB_LOGO; },
/* harmony export */   "Pc": function() { return /* binding */ STATIC_FILE; },
/* harmony export */   "TH": function() { return /* binding */ IMAGE_DEFAULT; },
/* harmony export */   "V5": function() { return /* binding */ SOCIAL_LIST; },
/* harmony export */   "a0": function() { return /* binding */ WEB_DESC; },
/* harmony export */   "h$": function() { return /* binding */ WEB_URL; },
/* harmony export */   "kG": function() { return /* binding */ WEB_KEYWORD; },
/* harmony export */   "qN": function() { return /* binding */ WEB_TITLE; },
/* harmony export */   "zK": function() { return /* binding */ IMAGE_NAME; }
/* harmony export */ });
/* unused harmony export ADDRESS_ORG */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78633);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52091);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);




/* -------------------------------------------------------------------------- */ /*                                   HEADER                                   */ /* -------------------------------------------------------------------------- */ var IMAGE_NAME = "logo-192.png"; // logo-192.png
var IMAGE_DEFAULT = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_IMG */ .T, "/default.jpg"); // default image
var WEB_TITLE = "ข่าวด่วน ข่าวล่าสุด ข่าววันนี้ วิเคราะห์ข่าวเศรษฐกิจ โดยกรุงเทพธุรกิจ";
var WEB_DESC = "กรุงเทพธุรกิจออนไลน์ นำเสนอข่าววันนี้ ข่าวด่วน ข่าวล่าสุดทั้งหมด เกี่ยวกับข่าวธุรกิจ ข่าวการเงิน ข่าวการค้า วิเคราะห์ข่าวเศรษฐกิจ ข่าวการลงทุน เพื่อการตัดสินใจอย่างมืออาชีพ";
var WEB_KEYWORD = "อ่านข่าวออนไลน์, กรุงเทพธุรกิจ, ข่าวเด่นประจำวัน, ข่าวโซเซียล, ข่าวธุรกิจ, การเงิน, เศรษฐกิจต่างประเทศ, คลิปข่าว, ข่าวบันเทิง";
var WEB_NAME = "bangkokbiznews";
var WEB_LOGO = "logo.png";
// export const TWITTER = {
//   HANDLE: 'กรุงเทพธุรกิจ',
//   SITE: '@ktnewsonline'
// };
var STATIC_FILE = {
    FB_APP_ID: "192332974272649",
    FB_PAGES: "135182934814",
    ICON_LOGO: "logo.svg",
    ICON_MASK: "bangkokbiznews.png",
    ICON_FAV: "favicon.ico",
    ICON_APPLE: "apple-touch-icon.png"
};
/* -------------------------------------------------------------------------- */ /*                                   FOOTER                                   */ /* -------------------------------------------------------------------------- */ var WEB_URL = {
    WEB: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_URL */ .FX, "/"),
    FACEBOOK: "https://www.facebook.com/bangkokbiznews",
    TWITTER: "https://twitter.com/ktnewsonline",
    YOUTUBE: "https://www.youtube.com/channel/UCwAoYpzi-LmKhRXlW4bMdBA",
    LINE: "https://line.me/R/ti/p/%40rvb8351i",
    INSTAGRAM: "https://www.instagram.com/bangkokbiznews/"
};
var ADDRESS_ORG = {
    CONTENT: "บริษัท กรุงเทพธุรกิจ มีเดีย จำกัด 1858/126 ชั้นที่ 30 ถนนเทพรัตน แขวงบางนาใต้ เขตบางนา",
    PROVINCE: "กรุงเทพฯ",
    REGION: "TH",
    POSTCODE: "10260",
    COUNTRY: "THAILAND"
};
var SOCIAL_LIST = [
    {
        id: 1,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaFacebookF */ .tBk, {
            id: "facebook",
            size: 16
        }),
        link: WEB_URL.FACEBOOK,
        name: "facebook",
        className: "icon-facebook"
    },
    {
        id: 2,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsTwitterX */ .AMt, {
            id: "x",
            size: 16
        }),
        link: WEB_URL.TWITTER,
        name: "x",
        className: "icon-x"
    },
    {
        id: 3,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsLine */ .GF9, {
            id: "line",
            size: 16
        }),
        link: WEB_URL.LINE,
        name: "line",
        className: "icon-line"
    }
];


/***/ }),

/***/ 84920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ads": function() { return /* binding */ Ads; },
/* harmony export */   "KEY_ADS_PAGE": function() { return /* binding */ KEY_ADS_PAGE; },
/* harmony export */   "KEY_ADS_POSITION": function() { return /* binding */ KEY_ADS_POSITION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 2147483647;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #4142429c;\n\n  &.close {\n    display: none;\n  }\n  .light-box {\n    position: relative;\n    &::before {\n      content: 'X';\n      cursor: pointer;\n      position: absolute;\n      top: -24px;\n      right: 0;\n      color: rgba(0, 0, 0, 0.788);\n      background-color: #fafafab7;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px;\n      padding: 2px 7px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.ads-billboard {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgb(245, 245, 245);\n    /* margin: 30px auto; */\n    min-height: 300px;\n    iframe {\n      margin: auto;\n    }\n    @media (max-width: 475px) {\n      min-height: 330px;\n    }\n  }\n  &.ads-ad1x1 {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n  &.ads-sticky-1,\n  &.ads-sticky-2,\n  &.ads-sticky-3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    margin-bottom: 15px;\n    min-height: 300px;\n    background: rgb(245, 245, 245);\n    padding: 15px;\n  }\n  &.ads-postarticle {\n    position: sticky;\n    bottom: 0;\n    z-index: 50;\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 90px;\n  }\n\n  &.ads-inarticle-1,\n  &.ads-inarticle-2,\n  &.ads-inarticle-3 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    margin: 5px auto;\n    overflow: hidden;\n    min-height: 90px;\n    background: rgb(245, 245, 245);\n    padding: 15px 0px;\n    img,\n    iframe {\n      max-width: 100%;\n      display: block;\n      margin: auto;\n    }\n  }\n  &.ads-election-1,\n  &.ads-election-2,\n  &.ads-election-3,\n  &.ads-election-4,\n  &.ads-election-5,\n  &.ads-election-6,\n  &.ads-election-7 {\n    margin: 15px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .mobile {\n    display: none;\n    @media (max-width: 1024px) {\n      display: block;\n    }\n  }\n  .desktop {\n    display: block;\n    @media (max-width: 1025px) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






// ? TODO:  <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} page={KEY_ADS_PAGE.CONTENT} />
/* -------------------------------- KEY_TYPE -------------------------------- */ var KEY_ADS_POSITION = {
    BILLBOARD: "billboard",
    STICKY_1: "sticky-1",
    STICKY_2: "sticky-2",
    STICKY_3: "sticky-3",
    INARTICLE_1: "inarticle-1",
    INARTICLE_2: "inarticle-2",
    INARTICLE_3: "inarticle-3",
    POSTARTICLE: "postarticle",
    AD1X1: "ad1x1",
    LIGHTBOX: "light-box",
    ELECTION_1: "election-1",
    ELECTION_2: "election-2",
    ELECTION_3: "election-3",
    ELECTION_4: "election-4",
    ELECTION_5: "election-5",
    ELECTION_6: "election-6",
    ELECTION_7: "election-7",
    RECTANGLE_A: "rectangle-a",
    RECTANGLE_B: "rectangle-b",
    RECTANGLE_C: "rectangle-c"
};
var KEY_ADS_PAGE = {
    HOMEPAGE: "homepage",
    CATEGORY: "category",
    CONTENT: "content",
    TAG: "tag",
    SEARCH: "search"
};
var Ads = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _slotId = param.slotId, slotId = _slotId === void 0 ? "" : _slotId, _slotSize = param.slotSize, slotSize = _slotSize === void 0 ? [] : _slotSize, _slotDefine = param.slotDefine, slotDefine = _slotDefine === void 0 ? "" : _slotDefine, _className = param.className, className = _className === void 0 ? "" : _className, position = param.position, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotId) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotDefine) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotSize)) return null;
    // const isDesktop = useDesktop();
    // const slotSize = isDesktop ? sizeDesktop : !_.isEmpty(sizeMobile) && sizeMobile;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        window.googletag.cmd.push(function() {
            window.googletag.defineSlot(slotDefine, slotSize, slotId).addService(window.googletag.pubads()).setCollapseEmptyDiv(true, true);
            window.googletag.pubads().enableSingleRequest();
            window.googletag.enableServices();
            window.googletag.cmd.push(function() {
                window.googletag.display(slotId);
            });
        });
    }, []);
    // console.log('position', position);
    // console.log('slotId', slotId);
    switch(position){
        case "light-box":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsLightBox, {
                    id: "ads-nlightbox",
                    className: "light-box-ads ".concat(!adsBox ? "close" : "open"),
                    style: {
                        filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : ""
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "light-box",
                        onClick: handler,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                            className: className,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                id: slotId
                            })
                        })
                    })
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                className: className,
                style: {
                    filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : "unset"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    id: slotId
                })
            });
    }
};
var AdsLightBox = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
var AdsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());
var DynamicAds = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _position = param.position, position = _position === void 0 ? "" : _position, _data = param.data, data = _data === void 0 ? [] : _data, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    var isMb = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(max-width: 1023px)"
    });
    var isDt = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(min-width: 1024px)"
    });
    var _adsArray = !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data) ? data : [];
    // เช็คตำแหน่ง ADS
    var _adsSlot = _adsArray.find(function(_data) {
        return (_data === null || _data === void 0 ? void 0 : _data.position) === position;
    });
    if (position === KEY_ADS_POSITION.POSTARTICLE) {
        // console.log(position, `ads-${position}`);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            className: "ads-sticky-overflow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    if (!lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(_adsSlot)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicAds);
// :: Default ::
// <Ads
//    className='ads'
//    slotDefine='/231599934,12270527/springnews/homepage/billboard'
//    slotId='div-gpt-ad-1622722566999-0'
//    slotSize=[[300, 250], [336, 280]] />
var SlotWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject2());


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ })

}]);